module.exports = __webpack_public_path__ + "img/bgtop4.61df03ba.jpg";